import { useRouter } from 'next/router'
import { useLayoutEffect, useEffect, useState } from 'react'

const readToken = (tokenLabel) => {
  // SSR
  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage.getItem(tokenLabel)
}

const savetoken = (tokenLabel, tokenValue) => {
  // SSR
  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage.setItem(tokenLabel, tokenValue)
}

export const useWebinarSusbcription = (webinar) => {
  const router = useRouter()
  const [token, setToken] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

  const handleSubscription = (event) => {
    if (!token) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpen(true)
    }
  }

  const handleSuscriptionSuccess = () => {
    const tokenValue = 'yes'
    const tokenLabel = `suscribed-to-webinar-${webinar.id}`
    savetoken(tokenLabel, tokenValue)
    setToken(tokenValue)
    router.push(`/webinars/${webinar.id}/${webinar.meta.slug}`)
  }

  useIsomorphicLayoutEffect(() => {
    const tokenLabel = `suscribed-to-webinar-${webinar.id}`
    setToken(readToken(tokenLabel))
  }, [])

  return {
    token,
    handleSubscription,
    suscribe: handleSubscription,
    modal: {
      isOpen: isModalOpen,
      setIsOpen: setIsModalOpen
    },
    form: {
      onSuccess: handleSuscriptionSuccess
    }
  }
}
